<template>
    <div>
        <kn-jumbotron></kn-jumbotron>
        <b-container fluid class="container1">
            <b-row id="mcRow">
                <kn-sideMenu></kn-sideMenu>
                <main role="main" class="ml-sm-auto pt-3 px-4 mx-auto col-md-9" style="max-width: 100%;">
                    <h2>
                        <span class="Block blue"></span>Επικοινωνήστε Μαζί μας:
                    </h2>
                    <b-card class="mt-4 p-4">
                        <b-row>
                            <b-col cols="12" md="6">
                                <h5><i class="fa-solid fa-person"></i> Ιδρυτής - Ιδιοκτήτης :</h5>
                                <p>Γεράσιμος - Θεόδωρος Μαγκανιώτης</p>
                                <h5><i class="fa-solid fa-person-dress"></i> Εκδότρια - Ιδιοκτήτρια:</h5>
                                <p>Σοφία Μαγκανιώτη</p>
                            </b-col>
                            <b-col cols="12" md="6">
                                <h5><i class="fa-solid fa-envelope"></i> Διεύθυνση:</h5>
                                <p>Ευξείνου Πόντου 161, Νέα Σμύρνη, 17123</p>
                                <h5><i class="fa-solid fa-at"></i> Email:</h5>
                                <p><a href="mailto:kimoliakanea@gmail.com" class="email-link">kimoliakanea@gmail.com</a>
                                </p>
                                <h5><i class="fa-solid fa-square-phone"></i> Τηλέφωνο:</h5>
                                <p>(+30) 210 9370430</p>
                            </b-col>
                        </b-row>
                    </b-card>
                </main>
            </b-row>
        </b-container>
        <kn-footer></kn-footer>
    </div>
</template>

<script>
import jumbotron from "./jumbotron.vue";
import sideMenu from "./sideMenu.vue";
import footer from "./footer.vue";

export default {
    components: {
        "kn-jumbotron": jumbotron,
        "kn-sideMenu": sideMenu,
        "kn-footer": footer,
    },
};
</script>

<style scoped>
.card-text {
    padding: 10px;
}

.email-link {
    color: black;
    text-decoration: none;
}

.email-link:hover {
    color: #0a4975;
}

h5 {
    text-decoration: underline;
}

.Block.blue {
  background: #4c81a6;  /* Background color */
  width: 5px;          /* Adjust width to control size */
  height: 23px;         /* Adjust height to control size */
  display: inline-block; /* Ensures it's treated as a box */
  margin-right: 5px;    /* Adds space between the square and text */
}

h2 {
  display: flex;          /* Enables flexbox for alignment */
  align-items: center;    /* Aligns text and block on the same line */
}
</style>


// WEBPACK FOOTER //
// src/components/contactUs.vue